import global from './global';
import avatar from './avatar';
import chip from './chip';
import skeleton from './skeleton';
import menu from './menu';

export default {
  global,
  avatar,
  chip,
  skeleton,
  menu
};
